import React from 'react';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

import lineBreaker from '../../../utils/lineBreaker';
import AlertDialog from '../../AlertDialog';
import Button from '../../Button';
import TextField from '../../Form/TextField';
import { Box } from '../../Grid';

const StyledError = styled(Box)`
  color: #e22062;
  font-size: 0.875rem;
  text-align: left;
  margin-top: -2.375rem;
`;

const FormDialog = ({
  errorText,
  errors,
  loginParams,
  modalVisible,
  onDismiss,
  onSubmit,
  register,
  clearError,
}) => {
  return (
    <AlertDialog ariaLabel="Formfield" isOpen={modalVisible} onDismiss={onDismiss}>
      <form data-testid="exchange-dialog" onSubmit={onSubmit}>
        <fieldset>
          <Box textAlign="right">
            {loginParams &&
              loginParams.formFields.map((field) => {
                const { ref, onChange, ...rest } = register(field.name, {
                  required: `Please enter your ${field.name} to continue`,
                  pattern: {
                    value: new RegExp(field.regex),
                    message: `Please enter a valid ${field.name} to continue`,
                  },
                });
                return (
                  <TextField
                    key={field.name}
                    errors={errors}
                    label={field.name}
                    name={field.name}
                    {...rest}
                    innerRef={ref}
                    onChange={(e) => {
                      onChange(e);
                      clearError(e);
                    }}
                  />
                );
              })}
            {errorText && isEmpty(errors) && (
              <StyledError dangerouslySetInnerHTML={{ __html: lineBreaker(errorText) }} />
            )}
            <Button data-testid="form-submit-button" type="submit">
              Submit
            </Button>
          </Box>
        </fieldset>
      </form>
    </AlertDialog>
  );
};

export default FormDialog;
